/**
 * Marco del panel de administración (docs/panel-admin.md): solo `es_admin`, con
 * submenú por sección. Nada de lo que muestra incluye contenido de reuniones.
 */
import { NavLink, Outlet } from 'react-router'
import { useApp } from '../../components/AppContext'

const SECCIONES: [string, string][] = [
  ['/admin', 'Resumen'],
  ['/admin/usuarios', 'Usuarios'],
  ['/admin/equipos', 'Equipos'],
  ['/admin/operacion', 'Operación'],
  ['/admin/costos', 'Costos'],
  ['/admin/promociones', 'Promociones'],
  ['/admin/auditoria', 'Auditoría'],
  ['/admin/ajustes', 'Ajustes']
]

export function AdminLayout() {
  const { me } = useApp()
  if (!me) return null
  if (!me.user.esAdmin)
    return (
      <div className="page narrow">
        <div className="empty">
          <h2>Esta página no existe</h2>
        </div>
      </div>
    )
  return (
    <div className="page">
      <div className="page-head">
        <h1 className="grow">Administración</h1>
      </div>
      <nav className="admin-nav" aria-label="Secciones de administración">
        {SECCIONES.map(([to, label]) => (
          <NavLink key={to} to={to} end={to === '/admin'}>
            {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  )
}
